import { Button, PersistentBanner } from '@7shifts/sous-chef';
import { useAuthContext } from 'contexts/AuthContext';
import { __ } from 'i18n/translate';
import { useState } from 'react';

const ImpersonateBanner = () => {
    const [isLoggingOut, setLoggingOut] = useState(false);
    const {
        user: { companyId, name, email }
    } = useAuthContext();

    const [isImpersonating] = useState(() => {
        return localStorage.getItem('impersonatorToken') !== null;
    });

    const handleImpersonateLogOut = () => {
        setLoggingOut(true);
        localStorage.setItem(
            'token',
            localStorage.getItem('impersonatorToken') || ''
        );
        localStorage.setItem(
            'refreshToken',
            localStorage.getItem('impersonatorRefreshToken') || ''
        );

        localStorage.removeItem('impersonatorToken');
        localStorage.removeItem('impersonatorRefreshToken');

        window.location.href = `/companies/${companyId}/users`;
    };

    if (!isImpersonating) {
        return null;
    }

    return (
        <PersistentBanner
            theme="danger"
            primaryButton={
                <Button
                    loading={isLoggingOut}
                    onClick={handleImpersonateLogOut}
                >
                    {__('main.logOut')}
                </Button>
            }
        >
            {__('adminpanel.impersonateBannerMessage', {
                name,
                email
            })}
        </PersistentBanner>
    );
};

export default ImpersonateBanner;
